import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { formatPhoneNumber } from "../utils/formatnumber";

const AllSetUpModal = ({ open, setOpen }) => {
 console.log( JSON.parse(localStorage.getItem("organization")))
  const [twilio, setTwilio] = useState(JSON.parse(localStorage.getItem("organization")).twilio_integration)
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">All Set Up!</div>


        <div className="lg:text-[14px] text-[13px] text-center">
        Go ahead and give a call to <span className='font-semibold'>
         
          {formatPhoneNumber(twilio.M.primary_phone.S)}</span> to test it out. You can now further customize your call route
         based on time of day and different notification settings.
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor:'white',
                    color: "#605BFF",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    border:'1px solid rgba(96,91,255,0.1)',
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> setOpen(false)}
                >
                  Okay
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default AllSetUpModal;
